import { addZ } from "@jugl-web/utils/date-time/addZ";
import { TicketListItemDto } from "./TicketListItemDto";
import { TicketListItemModel } from "./TicketListItemModel";

export const transformTicketListItemDtoToModel = (
  dto: TicketListItemDto
): TicketListItemModel => ({
  ...dto,
  due_at: dto.due_at ? addZ(dto.due_at) : null,
  inserted_at: addZ(dto.inserted_at),
  updated_at: addZ(dto.updated_at),
});
